import type { RouteRecordRaw } from 'vue-router';

import { RouteName } from '@/core/router/RouteName';
import { Scope } from '@/plugins/authentication/lib/UserPermissions';

const requiresScopes: Scope[] = [Scope.CONTRACTUEL_ACCESS_ALL];

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.REMUNERATIONS,
    path: '/remunerations',
    component: () => import('@/domains/remunerations/views/RootPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes,
    },
    redirect: { name: RouteName.REMUNERATIONS_SYNTHESE },
    props: true,
    children: [
      {
        name: RouteName.REMUNERATIONS_SYNTHESE,
        path: 'synthese',
        component: () => import('@/domains/remunerations/views/SynthesePage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.REMUNERATIONS_BORDEREAUX,
        path: 'bordereaux',
        component: () => import('@/domains/remunerations/views/BordereauxPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.REMUNERATIONS_BORDEREAUX_EMPRUNTEUR,
        path: 'bordereaux-emprunteur',
        component: () => import('@/domains/remunerations/views/BordereauxEmprunteurPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.REMUNERATIONS_COMPLEMENTAIRES,
        path: 'complementaires',
        component: () => import('@/domains/remunerations/views/RemunerationsComplementairesPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.REMUNERATIONS_ESCOMPTES,
        path: 'escomptes',
        component: () => import('@/domains/remunerations/views/EscomptesPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
    ],
  },
];

export default routes;
